export default __webpack_public_path__ + "static/media/logo.d5632bec.png";